exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option-button[data-v-458c878a]{--tw-bg-opacity:1;background-color:rgba(244,244,244,var(--tw-bg-opacity));--tw-border-opacity:1;border-color:rgba(221,221,221,var(--tw-border-opacity));flex:1 1 0%;height:100%;outline:2px solid transparent;outline-offset:2px;--tw-text-opacity:1;color:rgba(66,66,66,var(--tw-text-opacity))}.no-active[data-v-458c878a]{background-color:rgba(177,76,86,var(--tw-bg-opacity))}.no-active[data-v-458c878a],.yes-active[data-v-458c878a]{--tw-bg-opacity:1;--tw-text-opacity:1;color:rgba(255,255,255,var(--tw-text-opacity))}.yes-active[data-v-458c878a]{background-color:rgba(95,184,97,var(--tw-bg-opacity))}", ""]);

// exports
